import getMetadata from './getMetadata';

export default function isAutoplay(metadata) {
  return getMetadata(metadata).playmakerPlayBehavior === 'autoplay';
}
